module.exports = __webpack_public_path__ + "img/icon_sensor_current_1.7ca0959e.svg";